var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3479 1.56384L6.7479 12.1638C6.65402 12.2585 6.52622 12.3117 6.3929 12.3117C6.25958 12.3117 6.13178 12.2585 6.0379 12.1638L0.6479 6.7738C0.55324 6.68 0.5 6.5522 0.5 6.4188C0.5 6.2855 0.55324 6.1577 0.6479 6.0638L1.3479 5.3638C1.44178 5.2692 1.56958 5.2159 1.7029 5.2159C1.83622 5.2159 1.96402 5.2692 2.0579 5.3638L6.3879 9.6938L15.9379 0.143843C16.1357 -0.0479475 16.4501 -0.0479475 16.6479 0.143843L17.3479 0.853843C17.4426 0.947723 17.4958 1.07552 17.4958 1.20884C17.4958 1.34216 17.4426 1.46995 17.3479 1.56384Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.32735ce5511b96391ceff262990551b0.svg";
export { ForwardRef as ReactComponent };